export class RegionDriverEarningSettingEntity {
  id?: string
  regionId?: number
  regionName?: string | null
  multiDropoffDiscountPercentage?: number
}
